import {
  useQueryClient,
  useMutation,
  UseMutationResult,
} from '@tanstack/react-query';

import { deleteTicketCheckIn } from '../queries/submitCheckIns';

export function useDeleteCheckIn(): UseMutationResult<
  void,
  Error,
  { id: string; checkInId: string; isLast: boolean }
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, checkInId, isLast }) =>
      deleteTicketCheckIn(id, checkInId, isLast),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['ticketCheckIns'] }),
        queryClient.invalidateQueries({ queryKey: ['userTickets'] }),
        queryClient.invalidateQueries({ queryKey: ['checkIns'] }),
        queryClient.invalidateQueries({ queryKey: ['checkInSequence'] }),
      ]);
    },
  });
}
